export enum SubscriptionType {
 BASIC = 'basic',
 BUSINESS = 'business',
 ENTERPRISE = 'enterprise',
}
